import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AbstractControlOptions, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Utils } from '../../../utils/utils';
import { ChangePasswordRequestVM } from '../../../models/ChangePasswordRequestVM';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'account-settings',
  templateUrl: './settings.component.html'
})
export class SettingsComponent extends BaseComponent implements OnInit {

  model: ChangePasswordRequestVM;

  constructor(private route: ActivatedRoute,
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router) {
    super(route);
    this.model = new ChangePasswordRequestVM();
  }

  ngOnInit(): void {
    this.myForm = this.fb.group({
      newPassword: new FormControl('', [Validators.required, Validators.pattern(this.globalSettings.passwordRules)]),
      confirmPassword: new FormControl(null, Validators.required)
    }, { validator: Utils.checkIfMatchingPasswords('newPassword', 'confirmPassword') } as AbstractControlOptions);
  }

  onSubmit(value: string) {
    this.markAsTouched(this.myForm);
    if (this.myForm.valid) {
      this.model.username = this.me.username;
      this.emitDisplayLoadingDialog(true);
      this.authService.changePassword(this.model)
        .subscribe(returnValue => {
          if (returnValue) {
            this.showDialog("Changes saved successfully", false);
            this.model = new ChangePasswordRequestVM();
            this.myForm.reset();
          }
          else {
            this.showDialog("Changes not saved, please try again", true);
          }
        },
          error => { this.showDialog("Changes not saved, please try again", true); },
          () => { this.emitDisplayLoadingDialog(false); }
        )
    }
  }

  cancel() {
    this.router.navigateByUrl('/');
    return false;
  }

}
